import { Message } from "../messages/Message";


export class PHPResponse
{
  requestID:string = "";
  error:boolean = false;
  messages:Message[] = [];
}